<script lang="ts">
  import { BaseBtn, type BaseBtnProps } from '@/ui/base';

  type ProfileButtonProps = Pick<BaseBtnProps, 'label' | 'onclick'> & {
    avatar: string;
    selected?: boolean;
  };

  const { avatar, selected, ...rest }: ProfileButtonProps = $props();
</script>

<BaseBtn
  label="Profil"
  {...rest}
  class={`size-10 rounded-full bg-btn-profile ${selected ? 'bg-btn-profile-S' : 'hocus:bg-btn-profile-H'}`}
>
  {avatar}
</BaseBtn>
